import { GENERIC_VALIDATION_MESSAGE } from '../../blaze-plugins/shopware-fe-kp/components/constants';

const FORM_SCHEMAS = {
  type: 'object',
  properties: {
    accessCode: {
      fieldId: 'accessCode',
      label: 'Access Code',
      showInForm: true,
      formFieldType: 'text',
      type: 'string',
      minLength: 1,
      errorMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true
    }
  },
  required: ['accessCode']
};

const INVALID_ACCESS_CODE_MESSAGE = 'Invalid access code. Please try again.';

export { FORM_SCHEMAS, INVALID_ACCESS_CODE_MESSAGE };
